import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevelopmentDirective } from './development.directive';
import { DevelopmentOrTenantDirective } from './developmentOrTenant.directive';

@NgModule({
    declarations: [DevelopmentDirective, DevelopmentOrTenantDirective],
    imports: [CommonModule],
    exports: [DevelopmentDirective, DevelopmentOrTenantDirective],
})
export class DevelopmentModule {}
